var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"#modals-container"}},_vm._l((_vm.modals),function(modal){return _c('modal',_vm._g(_vm._b({key:modal.id,on:{"closed":function($event){return _vm.remove(modal.id)}}},'modal',modal.config,false),modal.events),[_c(modal.component,_vm._b({tag:"component",on:{"close":function($event){return _vm.$modal.hide(modal.config.name)}}},'component',modal.params,false))],1)}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e0136e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-js-modal/src/ModalsContainer.vue
// module id = 1015
// module chunks = 6